<template>
  <v-flex>
      <div ref="content">
      <v-card v-if="!justPlot">
          <v-hover>
              <v-card-text slot-scope="{ hover }" class="caption grey--text">
                  <v-layout style="min-height:40px;">
                      <loading-progress-bar :loading="loading" color="secondary"></loading-progress-bar>
                      <v-spacer></v-spacer>
                      <v-fade-transition>
                  <span v-show="(!loading && hover)" ma-0 pa-0>
                      <v-btn @click="downloadWithCSS" outline small flat round class="grey--text" ma-0 pa-0>
                          Export as PDF
                      </v-btn>
                      <v-btn @click="downloadCSV" outline small flat round class="grey--text" ma-0 pa-0>
                          Download CSV
                      </v-btn>
                  </span>
                      </v-fade-transition>
                      <span>{{facilityName}}</span>
                  </v-layout>
              </v-card-text>
          </v-hover>
              <vue-plotly disable-responsive :data="data" :layout="layout" :options="options" ref="plotly"/>
      </v-card>
          <vue-plotly show-export v-if="justPlot&&!loading" :data="data" :layout="layout" :options="options" ref="plotly"/>
      </div>
  </v-flex>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import {getCOP} from '@/helper'
import LoadingProgressBar from './LoadingProgressBar'
import jsPDF from 'jspdf'
import {exportCSVFromDicts} from "@/tocsv.js"
export default {
  props: {
    title: {type: String, default: ''},
    facility_name: {type: String, default: null},
    variableX: {type: String, default: 'timestamp'},
    variableY: {type: String, default: 'COP'},
    dateRange: {type: Object, default: null},
      layoutOverrides: {type: Object, default: null},
    type: {type: String, default: 'scatter'},
    mode: {type: String, default: 'lines'},
    ony2: {type: String, default: null},
      apiBaseUrl: {type: String, default: null},
      justPlot:{type:Boolean,default:false},
      extraVars:{type:Array,default:null}
  },
  components: {
    LoadingProgressBar,
    VuePlotly
  },
  computed: {
      layout(){
          let settings={
              title: this.title,
              hovermode: 'closest',
              xaxis: {
                  title: this.variableX
              },
              yaxis: {
                  title: this.type==='histogram'? 'Count' : this.variableY
              },
              legend: {
                  orientation: 'h',
                  y:-0.3
              },
              showlegend:true,
              height:300,
              margin:{
                  l: 50,
                  r: 50,
                  t: 30,
                  pad: 1
              },
          };
          if(this.layoutOverrides){
              settings=Object.assign({}, settings, this.layoutOverrides);
          }
          return settings;
      }
  },
  name: 'CopPlot',
  watch: {
    facility_name () {
      this.refresh()
    },
    variableX () {
      this.refresh()
    },
    variableY () {
      this.refresh()
    },
    dateRange () {
      this.refresh()
    }
  },
    data: function () {
        return {
            data: [],
            timeout:null,
            options: {},
            facilityName: this.facility_name,
            df: null,
            loading: true
        }
    },
  methods: {
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      downloadCSV () {
          exportCSVFromDicts(this.df)
      },
      download() {
          const doc = new jsPDF();
          const contentHtml = this.$refs.content.innerHTML;
          doc.fromHTML(contentHtml, 15, 15, {
              width: 170
          });
          doc.save("export.pdf");
      },
      async downloadWithCSS() {
          let doc = new jsPDF('', 'pt', 'a4');
          let img = null
              img =  await this.$refs.plotly.toImage()
              doc.addImage(img, 'JPEG', 0, 0,
                  1.0*595.28,
                  1.0*592.28/this.$refs.plotly.$refs.container.clientWidth*this.$refs.plotly.$refs.container.clientHeight
              )
          doc.save("export.pdf")
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
    async doRefresh() {
        if(this.facility_name){
            this.facilityName=this.facility_name;
        }
      this.loading=true
      if (!!this.variableX & !!this.variableY && !!this.facilityName){
          let df= await getCOP({
              facility_name: this.facilityName,
              from_date: this.dateRange.start,
              to_date: this.dateRange.end,
              apiBaseUrl: this.apiBaseUrl,
              extra_vars: this.extraVars
          })
        this.df = df
        let data = [
          {x: df[this.variableX], y: df[this.variableY],name:this.variableY, type: this.type, mode: this.mode, hovertext:this.variableX!=="timestamp" ? df["timestamp"] : null}
        ]
          if(this.ony2){
              data.push({
                  x: df[this.variableX], y: df[this.ony2],name:this.ony2, yaxis:'y2',type: this.type, mode: this.mode, hovertext:this.variableX!=="timestamp" ? df["timestamp"] : null
              })
          }
          this.data=data
          this.loading=false
      }

    },

  },
   mounted () {
    if (!this.facilityName) {
      this.facilityName = this.$store.state.pointsListStore.pointsList.facility_name
    }
    this.refresh()
  }
}

</script>
